import { SpeakerNotes } from "@material-ui/icons";
import { useState } from "react";
import { Button, Col, FloatingLabel, Form, Modal, Row } from "react-bootstrap";
import TextField from "../../designSystem/TextField";

const LocationNotes = ({ values, onChange }) => {
  const [isShow, setIsShow] = useState(false);
  const [previousDate, setPreviousDate] = useState("");

  const handleSave = () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0];
    setPreviousDate(formattedDate);
    setIsShow(false);
    // Perform any logic or actions based on the formattedDate
    // ...
  }

  return (
    <>
      <div onClick={() => setIsShow(true)}>
        <div><SpeakerNotes /> Notes</div>
      </div>
      <Modal
        size="md"
        show={isShow}
        onHide={() => setIsShow(false)}
        aria-labelledby="example-modal-sizes-title-md"
        id="product-desp"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-md">
            LocationNotes
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <fieldset>
              <label className="label-heading">Location Notes</label>
              <Row className="mb-3">
                <Col sm={2}>
                  <Form.Group controlId="date">
                    <FloatingLabel controlId="floatingInput" label="Previous Date" >
                      <Form.Control type="date" placeholder="Previous Date" name="previousdate" value={previousDate} />
                    </FloatingLabel>
                  </Form.Group>
                </Col>
                <Col sm={2}>
                  <TextField label="Street No." name="street" value={values?.street} disabled />
                </Col>
                <Col sm={4}>
                  <TextField label="Street Name" name="streetName" value={values?.streetName} disabled />
                </Col>
                <Col sm={2}>
                  <TextField label="Unit" name="unit" value={values?.unit} disabled />
                </Col>
                <Col sm={2}>
                  <TextField label="Postal code" name="postalCode" value={values?.postalCode} disabled />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={4}>
                  <TextField label="City" name="city" value={values?.cityName} disabled />
                </Col>
                <Col sm={4}>
                  <TextField label="Province" name="provineSateName" value={values?.provineSateName} disabled />
                </Col>
                <Col sm={4}>
                  <TextField label="Country" name="countryname" value={values?.countryname} disabled />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={4}>
                  <TextField label="Phone" name="phone" value={values?.phone} disabled />
                </Col>
                <Col sm={4}>
                  <TextField label="Contact" name="contact" value={values?.contact} disabled />
                </Col>
                <Col sm={4}>
                  <TextField label="Email" name="emailAddress" value={values?.emailAddress} disabled />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12}>
                  <FloatingLabel controlId="floatingTextarea2" label="Comments" >
                    <Form.Control
                      as="textarea"
                      placeholder="Leave a comment here"
                      style={{ height: '100px' }}
                      name="locationNotes" value={values?.locationNotes} onChange={onChange}
                    />
                  </FloatingLabel>
                </Col>
              </Row>
            </fieldset>
            <Row className="mt-3">
              <Col sm={10}></Col>
              <Col sm={2}><Button className="btn-primary" onClick={handleSave}>Save</Button></Col>
            </Row>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default LocationNotes;
